import React, { ReactElement } from 'react'
import { Checkbox, message, Modal } from 'antd'
import { debounce } from 'lodash'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { UserInfoHS } from 'src/commons/store/UserStore'
import { history } from 'src/commons/utils/WebCommons'
import { StyledAntDButton } from 'src/pc/assets/styled/CustomButton'
import { AppStore, GameLibraryStore } from 'src/pc/store/AppStore'
import { getYearJsqDays, HideCheckModal } from 'src/pc/store/UIController'
import { OpenLink } from './index'
import DDModal from 'src/pc/components/DDModal'
import Copy from 'copy-to-clipboard'
import AliPayIcon from 'src/pc/assets/icons/AliPayIcon.svg'
import BindInviteCodeSuc from 'src/pc/assets/icons/BindInviteCodeSuc.svg'
import CryIcon from 'src/pc/assets/icons/CryIcon.svg'
import MoneyIcon from 'src/pc/assets/icons/MoneyIcon.svg'
import QQWallet from 'src/pc/assets/icons/QQWallet.svg'
import SuccessIcon from 'src/pc/assets/icons/Success.svg'
import WarningIcon from 'src/pc/assets/icons/WarningIcon.svg'
import WeChatPayIcon from 'src/pc/assets/icons/WeChatPayIcon.svg'
import SuccessIcon2 from 'src/pc/assets/icons/iconsuccess.png'
import styled from '@emotion/styled'
import { useWaitModData } from '@hhpack/use-cms'

import BlizzardGameIcon from 'src/pc/assets/icons/BlizzardGameIcon.svg'
import UplayGameIcon from 'src/pc/assets/icons/UplayGameIcon.svg'
import RiotGameIcon from 'src/pc/assets/icons/RiotGameIcon.svg'
import SteamGameIcon from 'src/pc/assets/icons/SteamGameIcon.svg'
import OriginGameIcon from 'src/pc/assets/icons/OriginGameIcon.svg'
import EpicGameIcon from 'src/pc/assets/icons/EpicGameIcon.svg'
import MobileGameIcon from 'src/pc/assets/icons/MobileGameIcon.svg'
import line from 'src/pc/assets/images/line.png'
// DDModal.confirm({
//   title: `删除帖子`,
//   icon: null,
//   width: 487,
//   content: (
//     <>
//       <p style={{ fontSize: '14px', color: 'var(--text-color-4)' }}>
//           '删除评论后，其关联的回复将会一起从列表中删除哦，确定要删除该条评论吗？'
//       </p>
//     </>
//   ),
//   okText: `确认`,
//   onOk: () => {
//     // onOk && onOk()
//     // modal.destroy()
//   },
// })

// Modal.confirm({
//   className: 'custom postsConfirm',
//   title: `删除帖子`,
//   icon: null,
//   width: 487,
//   content: (
//     <>
//       <p style={{ fontSize: '14px', color: 'var(--text-color-4)' }}>
//           '删除评论后，其关联的回复将会一起从列表中删除哦，确定要删除该条评论吗？'
//       </p>
//     </>
//   ),
//   okText: `确认`,
//   onOk: () => {
//     // onOk && onOk()
//     // modal.destroy()
//   },
// })

//删除帖子或者回复
export const DeletePosts = (type: 'posts' | 'comments', isChecked?: boolean, onOk?: () => void) => {
  const modal = Modal.confirm({
    className: 'custom postsConfirm',
    title: type === 'posts' ? `删除帖子` : '删除评论',
    icon: null,
    width: 487,
    content: (
      <>
        <p style={{ fontSize: '14px', color: 'var(--text-color-4)' }}>
          {type === 'posts' ? (
            <>
              删除帖子后，帖子及其关联的回复将会一起从列表中删除。
              {!isChecked ? `帖子会保留在【回收站】但是其点赞数、回复数将做清零处理哦，` : ''} 确定要删除该帖子吗？
            </>
          ) : (
            '删除评论后，其关联的回复将会一起从列表中删除哦，确定要删除该条评论吗？'
          )}
        </p>
      </>
    ),
    okText: `确认`,
    onOk: () => {
      onOk && onOk()
      modal.destroy()
    },
  })
}

//实名认证提交成功
export const AuthSubmitSuccess = () => {
  const modal = Modal.success({
    title: (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <i className="anticon" style={{ marginRight: '8px' }}>
          <SuccessIcon />
        </i>
        <div style={{ fontSize: '18px', color: '#FFF', fontWeight: 600 }}>实名认证人工审核中</div>
      </div>
    ),
    icon: null,
    width: 400,
    content: (
      <div>
        <p style={{ fontSize: '14px', textAlign: 'center', marginTop: '20px', marginBottom: '0px' }}>
          审核将在24小时内完成，请耐心等待
        </p>
        <p style={{ fontSize: '14px', textAlign: 'center' }}>
          审核结果可在
          <span
            style={{ color: 'var(--embellish-color-1)', cursor: 'pointer' }}
            onClick={() => {
              history.push('/User/info')
              modal.destroy()
            }}
          >
            【我的信息】
          </span>
          查看
        </p>
      </div>
    ),
    okText: `知道了`,
    centered: true,
    className: 'custom',
  })
}
//国庆活动抽中游戏的试玩提示
export const DrawLotteryGame = (gameName: string, userGameId: number) => {
  const modal = Modal.confirm({
    className: 'custom NeedMargin',
    title: `提示`,
    icon: null,
    width: 400,
    content: (
      <>
        <p style={{ fontSize: '14px' }}>
          恭喜您，已抽中 <span style={{ color: '#ffc300' }}>【{gameName}】 </span>，可永久拥有哦，立即开始试玩吧
        </p>
        <div className="amountText">
          <p style={{ fontSize: '12px', color: '#929496', textAlign: 'left' }}>如订单发生退款，抽中的游戏会被收回哦</p>
        </div>
      </>
    ),
    okText: `立即试玩`,
    onOk: () => {
      history.push(`/Start/${userGameId}`)
      modal.destroy()
    },
  })
}

//国庆活动抽中CDK提示
export const DrawLotteryCDK = (cdkName: string) => {
  const modal = Modal.confirm({
    className: 'custom NeedMargin',
    title: `提示`,
    icon: null,
    width: 400,
    content: (
      <>
        <p style={{ fontSize: '14px' }}>
          恭喜您，已抽中 <span style={{ color: '#ffc300' }}>【{cdkName}】</span>，快去我的订单提取吧
        </p>
        <div className="amountText">
          <p style={{ fontSize: '12px', color: '#929496', textAlign: 'left' }}>如订单发生退款，抽中的CDK会被收回哦</p>
        </div>
      </>
    ),
    okText: `前往我的订单`,
    onOk: () => {
      history.push('/User/order')
      modal.destroy()
    },
  })
}
//国庆活动抽中加速器提示
export const DrawLotteryJsq = (jsqName: string) => {
  const modal = Modal.confirm({
    className: 'custom NeedMargin',
    title: `提示`,
    icon: null,
    width: 400,
    content: (
      <>
        <p style={{ fontSize: '14px' }}>
          恭喜您，已抽中<span style={{ color: '#ffc300' }}>【{jsqName}】</span>，快去我的订单提取吧
        </p>
        <div className="amountText">
          <p style={{ fontSize: '12px', color: '#929496', textAlign: 'left' }}>
            如订单发生退款，抽中的加速器会被收回哦
          </p>
        </div>
      </>
    ),
    okText: `前往我的订单`,
    onOk: () => {
      history.push('/User/order')
      modal.destroy()
    },
  })
}

//没有中奖提示
export const NoPrize = () => {
  return Modal.confirm({
    className: 'custom NeedMargin',
    title: `提示`,
    icon: null,
    width: 400,
    content: (
      <>
        <p style={{ fontSize: '14px', textAlign: 'center' }}>很遗憾没有中奖哦，再接再厉吧</p>
      </>
    ),
    okText: `再来一次`,
  })
}

export const NoBuyVip = () => {
  return Modal.confirm({
    className: 'custom NeedMargin',
    title: `提示`,
    icon: null,
    width: 400,
    content: (
      <>
        <p style={{ fontSize: '14px', textAlign: 'center' }}>您还未购买会员，抽奖次数为0</p>
      </>
    ),
    okText: `确认`,
  })
}

export const NoChance = ({ onOk }: { onOk?: (...args: any[]) => any }) => {
  return Modal.confirm({
    width: 417,
    zIndex: 1009,
    className: 'custom jsq-timeout',
    title: '提示',
    content: <div>您已完成3次抽取，请选择其中组合进行付款哦，付款完成后可重新抽取哦</div>,
    okText: '去选组合',
    onOk,
  })
}

export const CloseSDTipContent = (name: string) => {
  return [
    <p key={1} style={{ marginBottom: 0 }}>
      本助手由于处于VIP内测期，更新频繁，容易被安全软件误拦截
    </p>,
    <p key={2} style={{ marginBottom: 0 }}>
      请您启动时关闭“
      {name}
      ”软件，避免导致您启动游戏失败哦！
    </p>,
  ]
}
/**游戏平台图标*/
export const PlatformIcon: { [key: string]: ReactElement } = {
  1: <SteamGameIcon />,
  2: <OriginGameIcon />,
  4: <UplayGameIcon />,
  5: <EpicGameIcon />,
  6: <BlizzardGameIcon />,
  9: <RiotGameIcon />,
  12: <MobileGameIcon />,
}
/**平台名称*/
export const PlatformText: { [key: string]: string } = {
  1: 'Steam',
  2: 'Origin',
  4: 'Uplay',
  5: 'Epic',
  6: 'Blizzard',
  9: 'Riot',
  12: '手游',
}
/**平台色块配置*/
export const GamePlatformBlockConfig: {
  [key in GamePlatform]?: { backgroundImage: string; name: string; color: string }
} = {
  1: {
    backgroundImage: 'linear-gradient(180deg, #294691 0%, rgba(41,70,145,0.40) 100%)',
    name: 'STEAM',
    color: '#64AFEE',
  },
  5: {
    backgroundImage: 'linear-gradient(180deg, #7150A4 0%, rgba(113,80,164,0.20) 100%)',
    name: 'EPIC',
    color: '#C79CFF',
  },
  2: {
    backgroundImage: 'linear-gradient(180deg, #683B18 0%, rgba(105,61,70,0.30) 100%)',
    name: 'ORIGIN',
    color: '#F49522',
  },
  4: { backgroundImage: 'linear-gradient(180deg, #325261 0%, rgba(50,82,97,0.30) 100%)', name: 'UPLAY', color: '#CCC' },
  6: {
    backgroundImage: 'linear-gradient(180deg, #0C466A 0%, rgba(12,70,106,0.20) 100%)',
    name: 'BATTLENET',
    color: '#4FAEEB',
  },
  9: {
    backgroundImage: 'linear-gradient(180deg, #5C0314 0%, rgba(92,3,20,0.20) 100%)',
    name: 'RIOT',
    color: '#FB4453',
  },
  99: {
    backgroundImage: 'linear-gradient(180deg, #5C0314 0%, rgba(92,3,20,0.20) 100%)',
    name: '手机游戏',
    color: '#FB4453',
  },
}
export const JuvenileReminder = () => {
  const modal = Modal.confirm({
    className: 'custom NeedMargin',
    title: `温馨提示`,
    icon: null,
    width: 400,
    content: (
      <>
        <p style={{ fontSize: '14px', textAlign: 'center' }}>平台不对未成年人提供任何游戏服务</p>
        <div className="amountText">
          <p style={{ fontSize: '12px', color: '#929496' }}>
            对于给您带来的不便深感抱歉，如有需要，可前往
            <br />
            <span
              style={{ color: 'var(--embellish-color-1)', cursor: 'pointer' }}
              onClick={() => {
                history.push('/User/order')
                modal.destroy()
              }}
            >
              【我的订单】
            </span>
            发起退款申请
          </p>
        </div>
      </>
    ),
    okText: `确认`,
  })
}
export const ClosePluginTipContent = (GameName: string) => {
  return {
    title: (
      <>
        <i className="anticon">
          <WarningIcon />
        </i>
        经检测，您存在 (企图) 使用外挂，脚本，篡改游戏等违规行为，游戏终止！
      </>
    ),
    content: `温馨提示：超过1次检测出违规行为，您将永久失去《${GameName}》游戏登录权限 `,
  }
}

/*有正在运行的游戏提示内容*/
export const HasGameRunningModalContent = () => {
  return (
    <>
      <p>亲爱的玩家:</p>
      <p>您好,当前有正在运行的游戏,您确定要重新进入么?重新开始将会导致您正在运行的游戏掉线中断!</p>
    </>
  )
}

/*账号已提取提示*/
export const GameAccountExtracted = (msg: string) => {
  DDModal.warn({
    icon: null,
    title: '抱歉，您的账号已提取!',
    content: msg,
    centered: true,
  })
}

/*分页自定义渲染*/
export const PaginationItemRender = (
  page: number,
  type: 'page' | 'prev' | 'next' | 'jump-prev' | 'jump-next',
  originalElement: React.ReactElement<HTMLElement>,
) => {
  if (type === 'prev') {
    return (
      <a draggable={false} className="ant-pagination-item-link">
        上一页
      </a>
    )
  }
  if (type === 'next') {
    return (
      <a draggable={false} className="ant-pagination-item-link">
        下一页
      </a>
    )
  }
  return originalElement
}

/**
 * @deprecated 请使用showNeedDeposit
 * 需要缴纳保证金
 */
export const needDeposit = async (platform: GamePlatform, amount: number, Remove: () => void) => {
  const userInfo = UserInfoHS.SuccessResult
  const isVip = userInfo?.vip === 2
  const res = await useWaitModData<{ refundImg: string }>('simpleclient_margin_game')
  const img = res?.[0].refundImg
  Modal.info({
    className: 'custom-1',
    title: '温馨提示',
    icon: null,
    width: 511,
    closable: true,
    content: (
      <>
        <p style={{ lineHeight: 1.8, fontSize: 13 }}>
          亲爱的{isVip ? '会员' : '用户'}您好，
          <br />
          感谢您体验当前游戏，游戏开始前需要您支付
          <span style={{ color: 'var(--main-color)' }}>【押金{amount}元】</span>。
          <br />
          游戏期间没有违规操作，游戏结束后可在<span style={{ color: 'var(--main-color)' }}>【我的钱包】</span>
          申请退回押金。
          <br />
          感谢您的理解与支持！
        </p>
        {img && (
          <div style={{ paddingTop: 16 }}>
            <img src={img} alt="" style={{ maxWidth: '100%' }} />
          </div>
        )}
      </>
    ),
    okText: `¥${amount}  支付押金`,
    onOk: Remove,
  })
}

/**
 * 需要缴纳保证金弹窗
 */
export const showNeedDeposit = async (platform: GamePlatform, amount: number, gameId: number) => {
  const userInfo = UserInfoHS.SuccessResult
  const isVip = userInfo?.vip === 2
  const res = await useWaitModData<{ refundImg: string }>('simpleclient_margin_game')
  const img = res?.[0].refundImg
  Modal.info({
    className: 'custom-1',
    title: '温馨提示',
    icon: null,
    width: 511,
    closable: true,
    content: (
      <>
        <p style={{ lineHeight: 1.8, fontSize: 13 }}>
          亲爱的{isVip ? '会员' : '用户'}您好，
          <br />
          感谢您体验当前游戏，游戏开始前需要您支付
          <span style={{ color: 'var(--main-color)' }}>【押金{amount}元】</span>。
          <br />
          游戏期间没有违规操作，游戏结束后可在<span style={{ color: 'var(--main-color)' }}>【我的钱包】</span>
          申请退回押金。
          <br />
          感谢您的理解与支持！
        </p>
        {img && (
          <div style={{ paddingTop: 16 }}>
            <img src={img} alt="" style={{ maxWidth: '100%' }} />
          </div>
        )}
      </>
    ),
    okText: `¥${amount}  支付押金`,
    onOk: () => {
      AppStore.currentChargeDepositGameId = gameId
      AppStore.chargeDepositVisible = true
    },
  })
}

export const JsqContent = (cdk: string[], helpUrl?: string, modal?: any, target?: boolean) => {
  const CopyText = () => {
    const text = cdk.reduce((a, c) => {
      a += `${c.replace(/^【[\u4e00-\u9fa5_a-zA-Z0-9]*】/g, '').trim()}\n`
      return a
    }, '')
    Copy(text)
    message.success('复制成功!')
  }
  const AccountRender = (cdkStr: string) => {
    const ac = cdkStr.split('|')
    return (
      <>
        <p>
          账号：
          {ac[0]}
        </p>
        <p>
          密码：
          {ac[1]}
        </p>
      </>
    )
  }
  const linkProps = {
    ...(!target
      ? OpenLink(helpUrl, false, () => {
        modal.instance.destroy()
      })
      : { href: helpUrl }),
  }
  return (
    <div className="JsqContent">
      <div
        style={
          {
            // display: 'flex',
            // justifyContent: 'space-between',
            // alignItems: 'center'
          }
        }
      >
        {cdk.map((d, i) => (d.includes('|') ? AccountRender(d) : <p key={i}>{d}</p>))}
      </div>
      <p style={{ justifyContent: 'flex-start', paddingTop: 10 }}>
        <a draggable={false} onClick={CopyText}>
          点击复制
        </a>
        {helpUrl && (
          <a draggable={false} {...linkProps} style={{ marginLeft: 20 }}>
            如何兑换和使用？
          </a>
        )}
      </p>
    </div>
  )
}

export const JsqContentNew = (cdk: string[], gameId: number, platformType: number) => {
  // const gameDetailRes = await GameDetailHS.Execute({game_id: gameId})
  let CDKHelp: string = ''
  // 默认选中当前游戏平台的CDK教程
  for (let i = 0; i < AppStore.platFormProp?.length; i++) {
    if (AppStore.platFormProp[i].platformType === platformType.toString()) {
      CDKHelp = AppStore.platFormProp[i].image
    }
  }
  // 如果当前游戏有配置单独的CDK教程
  for (let i = 0; i < AppStore.platFormProp?.length; i++) {
    const gameIds = AppStore.platFormProp[i]?.gameId?.split(',') || []
    if (gameIds.includes(gameId.toString())) {
      CDKHelp = AppStore.platFormProp[i].image
      break
    }
  }

  const CopyText = () => {
    const text = cdk.reduce((a, c) => {
      a += `${c.replace(/^【[\u4e00-\u9fa5_a-zA-Z0-9]*】/g, '').trim()}\n`
      return a
    }, '')
    Copy(text)
    message.success('复制成功!')
  }
  const AccountRender = (cdkStr: string) => {
    const ac = cdkStr.split('|')
    return (
      <>
        <p>
          账号：
          {ac[0]}
        </p>
        <p>
          密码：
          {ac[1]}
        </p>
      </>
    )
  }
  return (
    <div className="JsqContent">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {cdk.map((d, i) => (d.includes('|') ? AccountRender(d) : <p key={i}>{d}</p>))}
        <a draggable={false} onClick={CopyText}>
          点击复制
        </a>
      </div>
      <p className="title">如何兑换和使用？</p>
      <div style={{ justifyContent: 'center' }}>
        {/* <img className="CDKCourseImage" src={CDKImage}/> */}
        <div dangerouslySetInnerHTML={{ __html: CDKHelp || '' }}></div>
      </div>
    </div>
  )
}

export const WifiNetworkTips = ({ onChange }: { onChange: (check: boolean) => void }) => {
  const CheckChange = (e: CheckboxChangeEvent) => {
    onChange(e.target.checked)
  }
  return (
    <>
      <StyledCheckMsg>检测到您当前使用的 WIFI，可能会出现延迟、连接不上等情况</StyledCheckMsg>
      <StyledCheckMsg>建议您换用网线连接，获得更好的游戏体验</StyledCheckMsg>
      <StyledCheckMsg>
        <Checkbox defaultChecked={false} onChange={CheckChange} />
        不再提示
      </StyledCheckMsg>
    </>
  )
}

export const OutOfMemoryTips = ({ onChange, memory }: { onChange: (check: boolean) => void; memory: number }) => {
  const CheckChange = (e: CheckboxChangeEvent) => {
    onChange(e.target.checked)
  }
  return (
    <>
      <StyledCheckMsg>
        检测到您的电脑内存较小（
        {memory}
        G），可能出现无法启动、卡顿等情况
      </StyledCheckMsg>
      <StyledCheckMsg>建议您升级配置，获得更好的游戏体验</StyledCheckMsg>
      <StyledCheckMsg>
        <Checkbox defaultChecked={false} onChange={CheckChange} />
        不再提示
      </StyledCheckMsg>
    </>
  )
}
const StyledCheckMsg = styled.p`
  text-align: left;
  margin-bottom: 0;
  .ant-checkbox-wrapper {
    margin-right: 6px;
  }
`

export const GameAccountIsInOffTime = ({ title, content }: { title?: string; content?: string }) => {
  return Modal.confirm({
    title: (
      <>
        <i className="anticon">
          <CryIcon />
        </i>
        {title}
      </>
    ),
    content,
    className: 'custom Queue noOk',
    cancelText: '一会儿再来',
  })
}
export const GameAccountIsFullTitle = () => {
  return (
    <>
      <i className="anticon">
        <CryIcon />
      </i>
      抱歉，当前所有线路已占满，系统正在解决中......
    </>
  )
}
/**支付类型名称*/
export const PayWayText = {
  alipay: '支付宝',
  wechat: '微信',
  qq_wallet: 'QQ钱包',
  balance: '余额支付',
}
/**支付类型图标*/
export const PayWayIcon = {
  alipay: <AliPayIcon />,
  wechat: <WeChatPayIcon />,
  qq_wallet: <QQWallet />,
  balance: <MoneyIcon />,
}

export const DownloadPlatform = (onOK: () => void) => {
  return (
    <StyledAntDButton type="primary" size="small" onClick={onOK}>
      立即下载
    </StyledAntDButton>
  )
}

export const JsErrorTip = ({
  onOk,
  onCancel,
}: {
  onOk?: (...args: any[]) => any
  onCancel?: (...args: any[]) => any
}) => {
  return Modal.confirm({
    width: 417,
    zIndex: 1009,
    className: 'custom jsq-timeout',
    title: '加速服务启动超时',
    content: (
      <div>当前游戏由于线路故障加速服务暂时无法正常启动，您可以选择稍后再启动游戏，或者继续以不加速状态进行游戏</div>
    ),
    cancelText: '停止上号',
    okText: '继续上号',
    onOk,
    onCancel,
  })
}

/**
 * 判断保证金是否微信支付，弹出不同提示
 */
export const checkChargeDepositTips = (isWechat: boolean) => {
  const key = 'DEPOSIT_GUIDE'
  if (isWechat && !localStorage.getItem(key)) {
    //是否需要引导如何申请退押金
    AppStore.depositGuide = AppStore.userInfoPopVisible = true
    localStorage.setItem(key, '1')
    Modal.info({
      className: `custom-1 deposit-guide`,
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={SuccessIcon2} style={{ marginRight: 8 }} alt="" />
          已支付押金，您可以开始畅玩游戏
        </div>
      ),
      icon: null,
      width: 450,
      closable: false,
      centered: true,
      maskStyle: { background: 'rgba(0,0,0,.7)' },
      content: (
        <p style={{ lineHeight: 1.8, fontSize: 13 }}>
          游戏期间没有违规操作，游戏结束后可在您的
          <span style={{ color: 'var(--main-color)' }}>【头像】处查看押金</span>。
          <br />
          押金需要您申请才可退回哦！
        </p>
      ),
      okText: '知道啦',
      onOk() {
        AppStore.depositGuide = AppStore.userInfoPopVisible = false
      },
    })
    return
  }
  message.success('已支付押金，您可开始畅玩游戏')
}

/**
 * 开始游戏检测到平台未安装的提示弹窗
 * @param platformName
 */
export const platformNotInstallTips = (platformName: string) => {
  console.log('checkEnv 平台未安装', platformName)
  HideCheckModal()
  DDModal.warn({
    title: '游戏平台启动失败',
    content: `因游戏官方限制，"${platformName}"平台需要您手动安装,请在辅助工具库下载安装后,再启动游戏`,
    okText: '前往下载',
    zIndex: 1006,
    style: { top: 250 },
    onOk: () => {
      // HideCheckModal()
      const platform = GameLibraryStore.currentTheRunningGameInfo?.platform
      if (platform) {
        const config = AppStore.GamePlatformConfig[platform]
        config &&
          window.FuluApp?.JSNotifyCppFunc(
            'notify_download_gameplatform',
            platform,
            config.md5,
            config.url,
            config.extend,
          )
      }
      AppStore.GameToolVisible = true
    },
  })
}

/**
 * 显示汉化包/mod/存档购买成功引导
 * @param type
 */
export const showGuideTips = (type: 'mod' | 'archive' | 'chinesePackage') => {
  if (!AppStore.showTipsGoodsId) {
    return
  }
  const map = {
    archive: {
      title: '已拥有当前存档，您可以开始畅玩游戏啦',
      desc: <>点击右下方【开始游戏】按钮，选择您购买的存档，确认启动后即可使用。</>,
    },
    mod: {
      title: '已拥有当前游戏MOD，点击下载MOD进行使用',
      desc: <>点击【下载MOD】，使用教程在压缩包内，请参照使用教程进行下载使用。</>,
    },
    chinesePackage: {
      title: '已拥有当前游戏汉化包，点击下载汉化包进行汉化',
      desc: <>点击【下载汉化包】，使用教程在压缩包内，请参照使用教程进行下载使用。</>,
    },
  }
  const data = map[type]
  const el = document.getElementById(`${type}-${AppStore.showTipsGoodsId}`)
  if (!el || !data) {
    return
  }

  const wrapEl = document.createElement('div')
  //复制一个按钮
  const cloneBtnEl = el.cloneNode(true) as HTMLElement
  const lineEL = document.createElement('div')
  wrapEl.appendChild(cloneBtnEl)
  wrapEl.appendChild(lineEL)

  const setElPosition = () => {
    el.scrollIntoView({
      block: 'center',
    })

    const { left, top, width } = el.getBoundingClientRect()
    const btnCenterX = width / 2 + left
    const boxLeft = btnCenterX - 450 / 2
    const boxTop = top - 300

    cloneBtnEl.style.cssText = `        
        position: fixed;
        z-index: 1001;
        left: ${left}px;
        top: ${top}px;       
        transform:translateY(0);
        pointer-events:none;
        transition:none;
      `
    lineEL.style.cssText = `
        background: url('${line}');
        position: fixed;
        z-index: 1001;
        left: ${btnCenterX - 6}px;
        top: ${top - 74}px;
        width: 12px;
        height: 71px;
        transform:rotate(180deg);
      `

    return { boxLeft, boxTop }
  }

  const { boxLeft, boxTop } = setElPosition()

  const modal = Modal.info({
    className: `custom-1`,
    title: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={SuccessIcon2} style={{ marginRight: 8 }} alt="" />
        {data.title}
      </div>
    ),
    icon: null,
    width: 450,
    closable: false,
    centered: true,
    keyboard: false,
    maskStyle: { background: 'rgba(0,0,0,.7)' },
    style: {
      position: 'fixed',
      left: boxLeft,
      top: boxTop,
    },
    content: <p style={{ lineHeight: 1.8, fontSize: 13 }}>{data.desc}</p>,
    okText: '知道啦',
    onOk() {
      resizeObserver.disconnect()
      document.body.removeChild(wrapEl)
    },
  })
  document.body.appendChild(wrapEl)
  //清除标识
  AppStore.showTipsGoodsId = 0

  //监听窗口大小/容器高度变化，防止图片加载完成后，高度变化引起的位置不准
  //@ts-ignore
  const resizeObserver = new ResizeObserver(
    debounce(
      entries => {
        entries.forEach((entry: any) => {
          // console.log('resizeObserver', entry)
          if (entry?.contentRect?.height === 0) {
            return
          }
          const { boxLeft, boxTop } = setElPosition()
          modal.update({
            style: {
              position: 'fixed',
              left: boxLeft,
              top: boxTop,
            },
          })
        })
      },
      300,
      { trailing: true },
    ),
  )

  resizeObserver.observe(document.getElementById('scrollContent'))
  resizeObserver.observe(document.getElementById('scroll-content'))

  return wrapEl
}
